// extracted by mini-css-extract-plugin
module.exports = {"menu-container":"index-module_menu-container_1iBhY","menu-item":"index-module_menu-item_rPITl"};